/**
 * Traverse the object3D tree and call the callback for each node.
 */
export const traverse = <TNode extends { children?: TNode[] }>(
  root: TNode,
  callback: (node: TNode) => void
): void => {
  callback(root);

  const children = root.children ?? [];
  for (let i = 0, l = children.length; i < l; i++) {
    traverse(children[i], callback);
  }
};
